import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: "hash",
  routes: [
    {
      path: "/",
      meta: {
        noRequireAuth: true, // 添加该字段，表示进入这个路由不需要登录
      },
      redirect: "/login", // 指定默认页面
    },
    {
      path: "/login",
      name: "login",
      meta: {
        noRequireAuth: true, // 添加该字段，表示进入这个路由不需要登录
      },
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/Login.vue"),
    },
    {
      path: "/main",
      name: "main",
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/Main.vue"),
    },
    {
      path: "/register",
      name: "register",
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/Register.vue"),
    },
    {
      path: "/fileMain",
      name: "fileMain",
      meta: {
        noRequireAuth: true, // 添加该字段，表示进入这个路由不需要登录
      },
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/FileMain.vue"),
    },
    {
      path: "/files",
      name: "files",
      meta: {
        noRequireAuth: true, // 添加该字段，表示进入这个路由不需要登录
      },
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/Files.vue"),
    },
  ],
});
